import { createSlice } from '@reduxjs/toolkit';
import ShippingSearchState from './types';
import {
  resetShippingSearchReducer,
  setShippingLookAheadKeyReducer,
  setShippingLookAheadOptionReducer,
} from './reducers';

export const INITIAL_SHIPPING_SEARCH_STATE: ShippingSearchState = {
  lookAheadOptionType: 'orderNumber',
  lookAheadOption: '',
  orderNumber: '',
  recipientName: '',
  recipientEmail: '',
};

export const shippingSearchSlice = createSlice({
  name: 'shippingSearchSlice',
  initialState: INITIAL_SHIPPING_SEARCH_STATE,
  reducers: {
    resetShippingSearchReducer,
    setShippingLookAheadKeyReducer,
    setShippingLookAheadOptionReducer,
    resetState: () => INITIAL_SHIPPING_SEARCH_STATE,
  },
});

export const {
  resetState,
  resetShippingSearchReducer: resetShippingSearch,
  setShippingLookAheadKeyReducer: setShippingLookAheadKey,
  setShippingLookAheadOptionReducer: setShippingLookAheadOptionAndKey,
} = shippingSearchSlice.actions;

export default shippingSearchSlice.reducer;
